export const localization = {
  pt: {
    text: 'O Blip Calls é uma nova funcionalidade do Blip Desk que permite que as empresas recebam, realizem e gerenciem ligações de voz no {0} sem sair da plataforma.',
    secondaryText: 'A partir de R$ 0,40 por minuto da chamada ativa*',
    buttonText: 'Contratar agora',
    title: 'Faça ligações por voz no WhatsApp sem sair do Blip Desk',
    title2: 'Chegou o Blip Calls',
    footer: 'Aprimore o atendimento e venda mais!',
    features: {
      title: 'Veja todos os recursos do Blip Calls',
      incomingCall: '{0} (ou ligações recebidas)',
      incomingCallBold: 'Ligações de voz receptivas',
      outboundCall: '{0} (ou ligações realizadas)',
      outboundCallBold: 'Ligações de voz ativas',
      recording: '{0} das ligações para melhor controle e gestão',
      recordigingBold: 'Gravação',
      transcription: '{0} para facilitar o gerenciamento do atendimento pela equipe',
      transcriptionBold: 'Transcrição',
      history: '{0} de ligações dos clientes',
      historyBold: 'Histórico',
      management: '{0} das atividades em tempo real',
      managementBold: 'Monitoramento',
      readMore: 'Saiba mais',
    },
    configurations: {
      title: 'Veja como é fácil configurar o Blip Calls',
      step1: {
        title: '1. Contrate o Blip Calls',
        description: 'Confira e aceite os termos de uso do Blip Calls e precificação.',
      },
      step2: {
        title: '2. Habilite a funcionalidade no Painel de Contrato',
        description: 'Autorize o uso do Calls nos bots.',
      },
      step3: {
        title: '3. Habilite o Calls nos bots',
        description: 'Escolha quais bots podem receber e realizar ligações.',
      },
      step4: {
        title: 'Disponibilize o Calls para atendentes',
        description: 'Escolha quais atendentes podem receber e realizar ligações.',
      },
    },
    questions: {
      title: 'Dúvidas frequentes',
      question1: {
        title: 'Para que serve o Blip Calls?',
        answer: 'O Blip Calls é um produto da Blip que permite integrar ligações de voz ao dia a dia do atendimento ao cliente, diretamente pelo Blip Desk.”',
      },
      question2: {
        title: 'Quais tipos de ligação são possíveis?',
        answer1: 'Existem dois tipos de ligações disponíveis:',
        answer2: '{0} quando o atendente liga para o cliente.',
        answer2Bold: 'Ligação ativa (ou realizada):',
        answer3: '{0} quando o cliente liga para o atendente.',
        answer3Bold: 'Ligação receptiva (ou recebida):',
      },
      question3: {
        title: 'Quais as vantagens de usar ligações no atendimento?',
        answer: '87% dos clientes ao redor do mundo preferem um atendimento que combine áudio e texto — ou seja, ligação e mensagem. Ter à disposição uma ferramenta que atende o cliente do jeito que ele se sente mais confortável melhora a resolutividade, aumenta a conversão em leads e, ainda assim, mantém todo o contexto da conversa.',
      },
      question4: {
        title: 'Precisa de alguma integração ou API para utilizar?',
        answer: 'Não. Apenas com a contratação, já é possível acessar o Blip Calls.',
      },
      question5: {
        title: 'Quais recursos estão disponíveis?',
        answer: 'Gravações (com reprodução e download), relatório de chamadas no Blip, transcrição das ligações e chamadas ativas (Marca > Consumidor).',
      },
      question6: {
        title: 'Como funciona a precificação?',
        answer: 'A ligação ativa tem um preço fixo de R$ 0,40 por chamada. Já a receptiva funciona por meio de franquia e faixas de preço conforme o consumo. O valor mínimo de R$ 225,00 dá direito a até 500 minutos de ligação.',
      },
    },
    readMoreLink: 'https://help.blip.ai/hc/pt-br/articles/26971911490199-Blip-Calls-Realizando-liga%C3%A7%C3%B5es-no-Desk',
    shortDescription: 'Destrave conversas complexas\nAumente a resolutividade\nMelhore a conversão',
    shortTitle: 'Mensagem & Voz em um único canal',
    dataText: 'dos consumidores em todo o mundo preferem marcas que ofereçam interações por meio de mensagens de voz. Tenha na mão a ferramenta que torna sua operação ainda mais eficiente e humanizada.',
  },
  en: {
    text: 'Blip Calls is a new feature of Blip Desk that allows companies to receive, make, and manage voice calls on {0} without leaving the platform.',
    secondaryText: 'Starting at $0,01 per minute for active calls*',
    buttonText: 'Hire now',
    title: 'Make voice calls on WhatsApp without leaving Blip Desk',
    title2: 'Blip Calls has arrived',
    footer: 'Enhance your service and sell more!',
    features: {
      title: 'See all the features of Blip Calls',
      incomingCall: '{0} (or received calls)',
      incomingCallBold: 'Incoming voice calls',
      outboundCall: '{0} (or made calls)',
      outboundCallBold: 'Outgoing voice calls',
      recording: '{0} of calls for better control and management',
      recordigingBold: 'Recording',
      transcription: '{0} to facilitate team management of service',
      transcriptionBold: 'Transcription',
      history: '{0} of customer calls',
      historyBold: 'History',
      management: '{0} of activities in real-time',
      managementBold: 'Monitoring',
      readMore: 'Learn more',
    },
    configurations: {
      title: 'See how easy it is to set up Blip Calls',
      step1: {
        title: '1. Hire Blip Calls',
        description: 'Check and accept the terms of use and pricing for Blip Calls.',
      },
      step2: {
        title: '2. Enable the feature in the Contract Panel',
        description: 'Authorize the use of Calls in bots.',
      },
      step3: {
        title: '3. Enable Calls in bots',
        description: 'Choose which bots can receive and make calls.',
      },
      step4: {
        title: 'Make Calls available to agents',
        description: 'Choose which agents can receive and make calls.',
      },
    },
    questions: {
      title: 'Frequently Asked Questions',
      question1: {
        title: 'What is Blip Calls for?',
        answer: 'Blip Calls is a Blip product that allows you to integrate voice calls into your customer service routine, directly through Blip Desk.',
      },
      question2: {
        title: 'What types of calls are available?',
        answer1: 'There are two types of calls available:',
        answer2: '{0} when the agent calls the customer.',
        answer2Bold: 'Active call (or made):',
        answer3: '{0} when the customer calls the agent.',
        answer3Bold: 'Incoming call (or received):',
      },
      question3: {
        title: 'What are the advantages of using calls in customer service?',
        answer: '87% of customers worldwide prefer a service that combines audio and text — that is, call and message. Having a tool that serves the customer in the way they feel most comfortable improves resolution rates, increases lead conversion, and still maintains the entire context of the conversation.',
      },
      question4: {
        title: 'Do I need any integration or API to use it?',
        answer: 'No. Just by hiring, you can already access Blip Calls.',
      },
      question5: {
        title: 'What features are available?',
        answer: 'Recordings (with playback and download), call report in Blip, call transcription, and active calls (Brand > Consumer).',
      },
      question6: {
        title: 'How does pricing work?',
        answer: 'The active call has a fixed price of R$0.40 per call. The incoming call works through a franchise and price ranges according to consumption. The minimum value of R$225.00 entitles you to up to 500 minutes of calls.',
      },
    },
    readMoreLink: 'https://help.blip.ai/hc/en-us/articles/26971911490199-Blip-Calls-Making-Calls-in-Desk', 
    shortDescription: 'Unlock complex conversations\nIncrease resolution rates\nImprove conversion',
    shortTitle: 'Message & Voice in one channel',
    dataText: 'of consumers worldwide prefer brands that offer interactions through voice messages. Have in hand the tool that makes your operation even more efficient and humanized.',
  },
  es: {
    text: 'Blip Calls es una nueva funcionalidad de Blip Desk que permite a las empresas recibir, realizar y gestionar llamadas de voz en {0} sin salir de la plataforma.',
    secondaryText: 'A partir de €0,01 (EURO) / $0,19 (MEX) por minuto de llamada activa*',
    buttonText: 'Contratar ahora',
    title: 'Realiza llamadas de voz en WhatsApp sin salir de Blip Desk',
    title2: 'Llega Blip Calls',
    footer: '¡Mejora tu servicio y vende más!',
    features: {
      title: 'Ve todas las funcionalidades de Blip Calls',
      incomingCall: '{0} (o llamadas recibidas)',
      incomingCallBold: 'Llamadas de voz entrantes',
      outboundCall: '{0} (o llamadas realizadas)',
      outboundCallBold: 'Llamadas de voz salientes',
      recording: '{0} de las llamadas para un mejor control y gestión',
      recordigingBold: 'Grabación',
      transcription: '{0} para facilitar la gestión del servicio por parte del equipo',
      transcriptionBold: 'Transcripción',
      history: '{0} de llamadas de clientes',
      historyBold: 'Historial',
      management: '{0} de actividades en tiempo real',
      managementBold: 'Monitoreo',
      readMore: 'Saber más',
    },
    configurations: {
      title: 'Ve cómo es fácil configurar Blip Calls',
      step1: {
        title: '1. Contrata Blip Calls',
        description: 'Revisa y acepta los términos de uso y precios de Blip Calls.',
      },
      step2: {
        title: '2. Habilita la funcionalidad en el Panel de Contrato',
        description: 'Autoriza el uso de Calls en los bots.',
      },
      step3: {
        title: '3. Habilita Calls en los bots',
        description: 'Elige qué bots pueden recibir y realizar llamadas.',
      },
      step4: {
        title: 'Pon Calls a disposición de los agentes',
        description: 'Elige qué agentes pueden recibir y realizar llamadas.',
      },
    },
    questions: {
      title: 'Preguntas frecuentes',
      question1: {
        title: '¿Para qué sirve Blip Calls?',
        answer: 'Blip Calls es un producto de Blip que permite integrar llamadas de voz en la rutina de atención al cliente, directamente a través de Blip Desk.',
      },
      question2: {
        title: '¿Qué tipos de llamadas están disponibles?',
        answer1: 'Hay dos tipos de llamadas disponibles:',
        answer2: '{0} cuando el agente llama al cliente.',
        answer2Bold: 'Llamada activa (o realizada):',
        answer3: '{0} cuando el cliente llama al agente.',
        answer3Bold: 'Llamada entrante (o recibida):',
      },
      question3: {
        title: '¿Cuáles son las ventajas de usar llamadas en el servicio al cliente?',
        answer: 'El 87% de los clientes en todo el mundo prefieren un servicio que combine audio y texto, es decir, llamada y mensaje. Tener una herramienta que atiende al cliente de la manera en que se siente más cómodo mejora las tasas de resolución, aumenta la conversión de clientes potenciales y aún mantiene todo el contexto de la conversación.',
      },
      question4: {
        title: '¿Necesito alguna integración o API para usarlo?',
        answer: 'No. Solo con la contratación, ya puedes acceder a Blip Calls.',
      },
      question5: {
        title: '¿Qué funcionalidades están disponibles?',
        answer: 'Grabaciones (con reproducción y descarga), informe de llamadas en Blip, transcripción de llamadas y llamadas activas (Marca > Consumidor).',
      },
      question6: {
        title: '¿Cómo funciona la fijación de precios?',
        answer: 'La llamada activa tiene un precio fijo de R$0,40 por llamada. La llamada entrante funciona a través de una franquicia y rangos de precios según el consumo. El valor mínimo de R$225,00 te da derecho a hasta 500 minutos de llamadas.',
      },
    },
    readMoreLink: 'https://help.blip.ai/hc/es-mx/articles/26971911490199-Blip-Calls-Realizando-llamadas-en-Desk',
    shortDescription: 'Desbloquea conversaciones complejas\nAumenta la tasa de resolución\nMejora la conversión',
    shortTitle: 'Mensaje y Voz en un solo canal',
    dataText: 'de los consumidores en todo el mundo prefieren marcas que ofrezcan interacciones a través de mensajes de voz. Ten en tus manos la herramienta que hace que tu operación sea aún más eficiente y humanizada.',
  },
};